import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const sendProjectToLegacy = api(async function sendProjectToLegacy({ projectId, incrementVersion, publish }) {
    return mutate(
        gql`
            mutation SendProjectToLegacy($projectId: String!, $incrementVersion: Boolean, $publish: Boolean) {
                sendProjectToLegacy(projectId: $projectId, incrementVersion: $incrementVersion, publish: $publish) {
                    success
                    error
                    warnings
                }
            }
        `,
        { projectId, incrementVersion, publish },
        { returns: "sendProjectToLegacy" }
    )
})
